import { Alert, AlertTitle } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getFlowisAvailability } from '../api/endpoints';
import { queryKeys } from '../api/queryKeys';
import { formatDateTime } from '../utils/format';

/** Slow on purpose: an outage is measured in minutes, and this must not become traffic of its own. */
const availabilityPollIntervalMs = 30000;

/**
 * Says when the hold-up is downstream. Without it a queued document looks the same whether Flowis is
 * unreachable or simply not reached yet, and the difference is what somebody watching this page
 * actually wants to know.
 */
export function FlowisAvailabilityBanner() {
  const { t } = useTranslation();
  const query = useQuery({
    queryKey: queryKeys.flowis.availability(),
    queryFn: ({ signal }) => getFlowisAvailability(signal),
    refetchInterval: availabilityPollIntervalMs,
  });

  // Silent while loading or if the check itself fails: a banner that cannot tell must say nothing
  // rather than raise an alarm about itself.
  if (!query.data || query.data.reachable) return null;

  const { downSince } = query.data;

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <AlertTitle>{t('availability.title')}</AlertTitle>
      {t('availability.body')}
      {downSince ? ` ${t('availability.downSince', { time: formatDateTime(downSince) })}` : ''}
    </Alert>
  );
}
